/** 跨页面共用的小 UI 原子。*/

import type { ReactNode } from 'react'

import { useLang } from '../contexts/LanguageContext'

export function Spinner({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <span
      className={`inline-block shrink-0 rounded-full border-2 border-current border-t-transparent [animation:spin_0.7s_linear_infinite] ${className}`}
      aria-hidden="true"
    />
  )
}

/** 居中的整页加载/空/错误占位。*/
export function CenterNote({ children }: { children: ReactNode }) {
  return (
    <div className="reveal-in flex flex-1 flex-col items-center justify-center gap-3 px-8 py-16 text-center">
      {children}
    </div>
  )
}

/** zh ⇄ en 语言切换 — 文字按钮，显示目标语言名。*/
export function LangToggle({ className = '' }: { className?: string }) {
  const { lang, setLang, t } = useLang()
  return (
    <button
      onClick={() => setLang(lang === 'zh' ? 'en' : 'zh')}
      className={`rounded-md px-2 py-1 text-xs text-dimmed transition-colors active:bg-hover ${className}`}
    >
      {t('lang.toggle')}
    </button>
  )
}
